import { render, staticRenderFns } from "./FormBuilderPreviewModal.vue?vue&type=template&id=1f632c7a&scoped=true&"
import script from "./FormBuilderPreviewModal.vue?vue&type=script&lang=js&"
export * from "./FormBuilderPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderPreviewModal.vue?vue&type=style&index=0&id=1f632c7a&prod&scoped=true&lang=css&"
import style1 from "./FormBuilderPreviewModal.vue?vue&type=style&index=1&id=1f632c7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f632c7a",
  null
  
)

export default component.exports